<template>
  <v-card style="min-height: 320px">
    <Subheader dense title="Add Filters" no-search />
    <v-card-text class="pa-0">
      <div id="nav-layout">
        <v-layout wrap fill-height>
          <v-window v-model="window">
            <v-window-item :value="0">
              <v-text-field box label="Search file name" v-model="fileNameInput" @keyup.enter="emitSearch" hint="Press `enter` or the icon to search">
                <template v-slot:append>
                  <v-btn icon left class="no-transition-delay" :color="fileNameInput ? 'info' : ''" @click="emitSearch">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <div class="px-2">
                <v-btn v-for="(button, index) in buttonList" :key="button.key" depressed block @click="toggleTo(index + 1)">{{ button.label }}</v-btn>
              </div>
            </v-window-item>
            <v-window-item v-for="(button, index) in buttonList" :key="index+1" :value="index+1">
              <v-toolbar dense flat>
                <v-btn icon @click="toggleTo(0)">
                  <v-icon>keyboard_arrow_left</v-icon>
                </v-btn>
                <v-toolbar-title>
                  {{ button.label }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <keep-alive>
                <component class="pa-2" :is="button.component" @returnEvent="handleUpdate($event)" @instantSearchEvent="handleUpdateWithoutToggle($event)" ref="nav-content" />
              </keep-alive>
            </v-window-item>
          </v-window>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import Subheader from '@/components/generic/Subheader'
  import DataSetNavigationStationCategory from './DataSetNavigationStationCategory'
  import DataSetNavigationLocation from './DataSetNavigationLocation'
  import DataSetNavigationTime from './DataSetNavigationTime'
  import DataSetNavigationMetadata from './DataSetNavigationMetadata'

  import {
    FileNameFilter,
  } from '@/components/plugins/DataSetFilter'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const datasetfilter = createNamespacedHelpers('datasetfilter')
  const buttonList = [{
    label: 'Monitoring Component',
    key: 'station-category',
    color: 'blue-grey lighten-1',
    component: 'data-set-navigation-station-category',
  },
  {
    label: 'Monitoring Location',
    key: 'station-name',
    color: 'blue-grey lighten-1',
    component: 'data-set-navigation-location',
  },
  {
    label: 'Date Created',
    key: 'time-created',
    color: 'blue-grey lighten-1',
    component: 'data-set-navigation-time',
  },
  {
    label: 'Metadata Field',
    key: 'station-metadata',
    color: 'blue-grey lighten-1',
    component: 'data-set-navigation-metadata',
  },
    //{
    //  label: 'Files needing review',
    //  key: 'invalid-metadata',
    //  color: 'warning',
    //  handler: () => console.log('toggle invalids'),
    //},
  ]
  export default {
    components: {
      DataSetNavigationStationCategory,
      DataSetNavigationLocation,
      DataSetNavigationTime,
      DataSetNavigationMetadata,
      Subheader,
    },
    data() {
      return {
        window: 0,
        buttonList,
        fileNameInput: '',
      }
    },
    computed: {
      ...datasetfilter.mapGetters(['fileNameSearchString']),
    },
    methods: {
      ...datasetfilter.mapActions(['addFilter']),
      toggleTo(i) {
        this.window = i
      },
      handleUpdate() {           
        this.toggleTo(0)
        this.emitSearch()
      },
      handleUpdateWithoutToggle() {                   
        this.emitSearch()
      },
      onInputFileName() {
        this.addFilter(new FileNameFilter(this.fileNameInput))
      },
      emitSearch() {
        this.onInputFileName()
        this.$emit('search')
      },
    },
    mounted() {
      this.fileNameInput = this.fileNameSearchString
    },
  }
</script>

<style scoped>
  div.layout {
    width: 100%;
  }

  div.v-window {
    width: 100%;
    height: 100%;
  }

  div.v-window-item {
    width: 100%;
    height: 100%;
  }

  #nav-layout {
    width: 100%;
    height: 100%;
  }

  div.v-toolbar__title {
    font-size: 14px;
  }

  /* When switching colors, some components' transition causes stutter, so this will disable the transition delay */
  .no-transition-delay> {
    transition: 0s !important;
    transition-delay: 0s !important;
  }

  .no-transition-delay>div {
    transition: 0s !important;
    transition-delay: 0s !important;
  }

  .no-transition-delay>div>i {
    transition: 0s !important;
    transition-delay: 0s !important;
  }

  /* end */
</style>
